var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDifference(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F9ECD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5V16.5M3.5 10H16.5M5.5 6.75H8M12.25 6.75H14.25M12.25 12.25H14.25M12.25 14.25H14.25M6.75 5.5V8M5.69 12.19L7.81 14.31M7.81 12.19L5.69 14.31M14.5 3.5H5.5C4.96957 3.5 4.46086 3.71071 4.08579 4.08579C3.71071 4.46086 3.5 4.96957 3.5 5.5V14.5C3.5 15.0304 3.71071 15.5391 4.08579 15.9142C4.46086 16.2893 4.96957 16.5 5.5 16.5H14.5C15.0304 16.5 15.5391 16.2893 15.9142 15.9142C16.2893 15.5391 16.5 15.0304 16.5 14.5V5.5C16.5 4.96957 16.2893 4.46086 15.9142 4.08579C15.5391 3.71071 15.0304 3.5 14.5 3.5Z",
    stroke: "#AC6600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDifference);
export default __webpack_public_path__ + "static/media/icon-difference.7f7fb95923a6e23e45cf2604c32eebaa.svg";
export { ForwardRef as ReactComponent };